module.exports = {
          srcSet: __webpack_public_path__ + "public/images/5fc21f61260597fd5b0c7570cd0d0257-414.webp"+" 414w",
          images:[ {path: __webpack_public_path__ + "public/images/5fc21f61260597fd5b0c7570cd0d0257-414.webp",width: 414,height: 850}],
          src: __webpack_public_path__ + "public/images/5fc21f61260597fd5b0c7570cd0d0257-414.webp",
          toString:function(){return __webpack_public_path__ + "public/images/5fc21f61260597fd5b0c7570cd0d0257-414.webp"},
          
          width: 414,
          height: 850
        }